import { FaHeart, FaStore } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import type { Product } from '../../types';

interface ProductCardProps {
  product: Product;
}

const currencyFormatter = new Intl.NumberFormat('es-CR', {
  style: 'currency',
  currency: 'CRC',
  maximumFractionDigits: 0
});

const ProductCard = ({ product }: ProductCardProps) => {
  const hasPriceRange = product.priceMax !== undefined && product.priceMax > product.price;
  const priceLabel = hasPriceRange
    ? `${currencyFormatter.format(product.price)} - ${currencyFormatter.format(product.priceMax || product.price)}`
    : currencyFormatter.format(product.price);
  const storeLabel = product.storeName || (product.storeId ? `Local ${product.storeId}` : 'El Mercadito');

  return (
    <article className="product-card">
      <div className="product-card__image-wrapper">
        <img src={product.image} alt={product.name} />
        {product.badge ? <span className="product-badge">{product.badge}</span> : null}
        <button type="button" className="wishlist-button" aria-label="Agregar a favoritos">
          <FaHeart />
        </button>
      </div>

      <div className="product-card__body">
        <span className="product-store">
          <FaStore /> {storeLabel}
        </span>
        <h3>{product.name}</h3>
        {product.sku ? <span className="product-sku">SKU: {product.sku}</span> : null}

        <div className="price-row">
          <strong>{priceLabel}</strong>
          {product.oldPrice ? <span>{currencyFormatter.format(product.oldPrice)}</span> : null}
        </div>

        {product.sizes?.length ? (
          <div className="sizes-row">
            {product.sizes.map((size) => (
              <span key={size}>{size}</span>
            ))}
          </div>
        ) : null}

        <div className="product-card-actions">
          <Link to={`/productos/${product.id}`} className="details-button">
            Ver detalle
          </Link>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
